import React from 'react'
import { type DateRange } from 'react-day-picker'
import { useTranslation } from 'react-i18next'
import { Box, Button, DatePicker, Icon } from '@node-space/ui-components'

export interface EarnHistoryFiltersProps {
  dateRange?: DateRange
  onDateRangeChange: (range: DateRange) => void
  onExportClick: () => void
}

export const EarnHistoryFilters = ({
  dateRange,
  onDateRangeChange,
  onExportClick,
}: EarnHistoryFiltersProps) => {
  const { t } = useTranslation()

  return (
    <Box flex gapX={12} gapY={12} isFlexWrap>
      <Box className="w-[240px]">
        <DatePicker
          mode="range"
          id="earn-history-date-range"
          label=""
          initialSelected={dateRange}
          onSelect={onDateRangeChange}
        />
      </Box>
      <Button
        variant="secondary"
        iconElement={<Icon name="DownloadSimple" />}
        onClick={onExportClick}
      >
        {t('earn.export')}
      </Button>
    </Box>
  )
}
